import { render, staticRenderFns } from "./Coffeshop.vue?vue&type=template&id=7824173c"
import script from "./Coffeshop.vue?vue&type=script&lang=js"
export * from "./Coffeshop.vue?vue&type=script&lang=js"
import style0 from "./Coffeshop.vue?vue&type=style&index=0&id=7824173c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports